import gql from "graphql-tag";

export default gql(`
mutation ($input: DeleteTaskInput!){
    deleteTask(input: $input) {
        id
    }
}`);

